import {EntityService} from '../../../../service/EntityService';

export class UserPermisionDataAppService extends EntityService {
  static entity = 'api/app/user-permision-data';
   
}
